import {OFFER_LIST_PAGE_SIZE} from "../list/constants/offer_list";
import {IOfferModalState} from "../types/OfferModalState";

export const offerModalInitialState: IOfferModalState = {
    isOpen: false,
    offer: null,
    offerId: null,
    position: 1,
    listingPage: 1,
    listingPageSize: OFFER_LIST_PAGE_SIZE,
    query: null,
    sort: null,
    page: 1,
    pageSize: 6,
    latestNavUsed: null,
    filters: {
        rooms: {
            lower: "",
            upper: ""
        },
        area: {
            lower: "",
            upper: ""
        },
        floor_choices: []
    },
    sourceSection: null,
    type: "tiles",
    gtmSource: "additional",
    amplitudeItemListContext: null
};
import {OFFER_LIST_PAGE_SIZE} from "../list/constants/offer_list";
import {IOfferModalState} from "../types/OfferModalState";

export const offerModalInitialState: IOfferModalState = {
    isOpen: false,
    offer: null,
    offerId: null,
    position: 1,
    listingPage: 1,
    listingPageSize: OFFER_LIST_PAGE_SIZE,
    query: null,
    sort: null,
    page: 1,
    pageSize: 6,
    latestNavUsed: null,
    filters: {
        rooms: {
            lower: "",
            upper: ""
        },
        area: {
            lower: "",
            upper: ""
        },
        floor_choices: []
    },
    sourceSection: null,
    type: "tiles",
    gtmSource: "additional",
    amplitudeItemListContext: null
};
